"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AddPaymentDialog',
  data: function data() {
    return {
      dialogVisible: false,
      form: {
        paymentAmount: null,
        paymentDate: '',
        feishuApplyNo: '',
        voucher: '',
        remark: ''
      },
      rules: {
        paymentAmount: [{
          required: true,
          message: '请输入打款金额',
          trigger: 'blur'
        }],
        paymentDate: [{
          required: true,
          message: '请选择打款日期',
          trigger: 'change'
        }],
        feishuApplyNo: [{
          required: true,
          message: '请输入飞书申请编号',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    open: function open() {
      var _this = this;
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.form = {
        paymentAmount: this.getDefaultPaymentAmount(row),
        paymentDate: this.getCurrentDateTime(),
        feishuApplyNo: '',
        voucher: '',
        remark: ''
      };
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this.$refs.form && _this.$refs.form.clearValidate();
      });
    },
    handleClose: function handleClose() {
      this.$refs.form.resetFields();
      this.dialogVisible = false;
    },
    handleSubmit: function handleSubmit() {
      this.$refs.form.validate(function (valid) {
        if (valid) {
          // 仅作演示，不做实际提交
        }
      });
    },
    getDefaultPaymentAmount: function getDefaultPaymentAmount(row) {
      var amount = row.actualAmount || row.actualSettlementAmount || 0;
      return Number(Number(amount).toFixed(2));
    },
    getCurrentDateTime: function getCurrentDateTime() {
      var date = new Date();
      var pad = function pad(value) {
        return String(value).padStart(2, '0');
      };
      return "".concat(date.getFullYear(), "-").concat(pad(date.getMonth() + 1), "-").concat(pad(date.getDate()), " ").concat(pad(date.getHours()), ":").concat(pad(date.getMinutes()), ":").concat(pad(date.getSeconds()));
    }
  }
};